/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line
// $(document).ready(function(){$(".product-variants .variant").click(function(){var t;t=$(this).find(".item").data("varr"),$("#pr_id").val(),jQuery.ajax({type:"POST",url:"/cart/add.js",data:{id:t,quantity:1},dataType:"json",success:function(){console.log("Single Item added to cart"),document.documentElement.dispatchEvent(new CustomEvent("cart:refresh",{bubbles:!0})),jQuery.getJSON("/cart.js",function(t){var a="Cart("+t.item_count+")";$(".header__icon--cart").text(a)})},error:function(){ths_val.addClass("cursor_disabled")}})})});


$(document).ready(function() {
  // Handle product variant selection
  $(".product-variants .variant").click(function(e) {
    e.preventDefault();
    var variant_id = $(this).find(".item").data("varr");
    $(this).closest('.product-item').find(".shopify-product-form .variant_idd").val(variant_id);
    $(this).closest('.product-item').find(".shopify-product-form .quick-add__button").click();
  });

  // Function to add a single item to the cart
  function addSingItemToCart(varval) {
    var data = {
      "id": varval,
      "quantity": 1
    };
    
    jQuery.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: data,
      dataType: 'json',
      success: function() { 
        console.log('Single Item added to cart');
        document.dispatchEvent(new CustomEvent('theme:cart:refresh', { bubbles: true }));
        document.dispatchEvent(new CustomEvent('theme:cart:open', { bubbles: true }));
        openCartDrawerOnProductAdded();

        jQuery.getJSON('/cart.js', function(cart) {
          var item = cart.item_count;
          $('.header__cart__status').text(item);
        });
      },
      error: function() {
        console.log('Error adding item to cart');
      }
    });
  }

  // Handle "Load More" button click
  $('.js-load-more').on('click', function() {
    var $this = $(this),
        totalPages = parseInt($('[data-all-pages]').val()),
        currentPage = parseInt($('[data-this-page]').val()),
        datacollurl = $('[data-coll-url]').val();

    if (currentPage >= totalPages) {
      $this.find('[load-more-text]').text('Products Finished').removeClass('hide');
      $this.find('[loader]').addClass('hide');
      return;
    }

    $this.attr('disabled', true);
    $this.find('[load-more-text]').addClass('hide');
    $this.find('[loader]').removeClass('hide');

    var nextUrl = $('[data-next-link]').val();
    var current_page_new = currentPage + 1;
    var next_coll = currentPage + 2;

    $.ajax({
      url: nextUrl,
      type: 'GET',
      dataType: 'html',
      success: function(responseHTML) {
        $('[data-next-link]').val(datacollurl + "?page=" + next_coll);
        $('[data-this-page]').val(current_page_new);
        $('#CollectionLoop').append($(responseHTML).find('#CollectionLoop').html());
      },
      complete: function() {
        if (current_page_new < totalPages) {
          $this.attr('disabled', false);
          $this.find('[load-more-text]').removeClass('hide');
          $this.find('[loader]').addClass('hide');
        } 
        if (current_page_new >= totalPages) {
          $this.find('[load-more-text]').text('Products Finished').removeClass('hide');
          $this.find('[loader]').addClass('hide');
        }
      }
    });
  });

  // Initial check for "Load More" button visibility
  var totalPages = parseInt($('[data-all-pages]').val()),
      currentPage = parseInt($('[data-this-page]').val());

  if (currentPage >= totalPages) {
    $('.js-load-more').find('[load-more-text]').text('Products Finished').removeClass('hide');
    $('.js-load-more').find('[loader]').addClass('hide');
    $('.js-load-more').attr('disabled', true);
  }
});


  
})();
